import { useSelector } from "react-redux";

import messages from "../../../../../assets/locale/messages";
import CompanyInfoSection from "../components/CompanyInfoSection";
import {
  CalendarCheckSmallIcon,
  CardSmallIcon,
  CardSwitchSmallIcon,
  CardTypeSmallIcon,
  DollarArrowSmallIcon,
  LocationSmallIcon
} from "../../../../../utils/Icons";
import { formatDate } from "../../../../../utils/Helpers";
import {
  CURRENCIES_IDS,
  CURRENCIES_SYMBOLS
} from "../../../../../utils/Constants";

const OnlinePaymentRequest = () => {
  const lang = useSelector((state) => state.locale.lang);
  const {
    businessVerification: {
      requestDetails: { onlinePayment }
    }
  } = messages[lang];

  const requestDetails = useSelector(
    (state) =>
      state.businessVerification
        .onlinePaymentVerificationRequestDetails
  );

  const renderTransactionInfo = (icon, label, value) => (
    <div className="col-12 col-md-6 mb-4">
      <div className="d-flex align-items-center">
        <div className="me-4">{icon}</div>
        <div>
          <p className="mb-1 text-light-grey fsize-13">{label}</p>
          <p className="mb-0 text-color fsize-15 fweight-600 word-break">
            {value || "--"}
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="online-payment-request-details">
      <div className="white-bg border-radius-10 p-4 mb-3">
        <CompanyInfoSection />
        <div className="transaction-section pt-4">
          <h6 className="title-color fsize-16 fweight-600 mb-4">
            {onlinePayment.transactionsInfo}:
          </h6>
          <div className="row">
            {renderTransactionInfo(
              <CardSwitchSmallIcon />,
              onlinePayment.id,
              requestDetails?.PaymentIntentId
            )}
            {renderTransactionInfo(
              <CardSmallIcon />,
              onlinePayment.accountName,
              requestDetails?.BillingName
            )}
            {renderTransactionInfo(
              <CardTypeSmallIcon />,
              onlinePayment.paymentMethod,
              requestDetails?.BillingCardType
            )}
            {renderTransactionInfo(
              <DollarArrowSmallIcon />,
              onlinePayment.amount,
              `${requestDetails?.CurrencyId === CURRENCIES_IDS.usd ? CURRENCIES_SYMBOLS.usd : CURRENCIES_SYMBOLS.euro} ${requestDetails?.Amount}`
            )}
            {renderTransactionInfo(
              <CalendarCheckSmallIcon />,
              onlinePayment.date,
              formatDate(requestDetails?.PaymentIntentDate)
            )}
            {renderTransactionInfo(
              <LocationSmallIcon />,
              onlinePayment.country,
              requestDetails?.CountryName
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlinePaymentRequest;
